import { formatYmd } from "./dateRange";

/** Дата открытия смены в формате YYYY-MM-DD. */
export function getShiftOpenDateKey(openDate) {
  if (openDate == null || openDate === "") return null;
  const raw = String(openDate).trim();
  const m = raw.match(/^(\d{4}-\d{2}-\d{2})/);
  if (m) return m[1];
  const d = new Date(raw.replace(" ", "T"));
  if (!Number.isNaN(d.getTime())) return formatYmd(d);
  return null;
}

/** Смена ещё не закрыта. */
export function isShiftStillOpen(shift) {
  if (!shift) return false;
  const st = shift.sessionStatus ?? shift.sessionStaus;
  if (st === "OPEN") return true;
  if (st === "CLOSED" || st === "ACCEPTED") return false;
  if (!shift.closeDate) return true;
  return false;
}

/**
 * Нужно ли исключить последний торговый день из дневной аналитики.
 * @returns {{ exclude: boolean, dateIso: string|null, dateLabel: string|null }}
 */
export function resolveLastDayExclusion(openDateIso = [], openDate = [], shifts = []) {
  if (!openDateIso.length) {
    return { exclude: false, dateIso: null, dateLabel: null };
  }

  const dateIso = openDateIso[openDateIso.length - 1] || null;
  const dateLabel = openDate[openDate.length - 1] || dateIso;

  const dayShifts = (shifts || []).filter((s) => getShiftOpenDateKey(s.openDate) === dateIso);

  if (dayShifts.length > 0) {
    const hasOpen = dayShifts.some(isShiftStillOpen);
    return { exclude: hasOpen, dateIso, dateLabel };
  }

  // Нет смен за день — если это сегодня, считаем день незавершённым
  const today = formatYmd(new Date());
  if (dateIso === today) {
    return { exclude: true, dateIso, dateLabel };
  }

  return { exclude: false, dateIso, dateLabel };
}

export function sliceClosedPeriod(arr, excludeCount = 0) {
  if (!Array.isArray(arr) || !excludeCount) return arr || [];
  if (arr.length <= excludeCount) return [];
  return arr.slice(0, -excludeCount);
}

/**
 * Контекст периода для подсказок: обрезанные ряды без незакрытого последнего дня.
 */
export function buildDashboardPeriodContext(store, shifts = []) {
  const openDateIso = store?.openDateIso || [];
  const openDate = store?.openDate || [];
  const exclusion = resolveLastDayExclusion(openDateIso, openDate, shifts);
  const trimCount = exclusion.exclude ? 1 : 0;
  const trim = (arr) => sliceClosedPeriod(arr, trimCount);

  return {
    excludeLastDay: exclusion.exclude,
    excludedDateIso: exclusion.dateIso,
    excludedDateLabel: exclusion.dateLabel,
    closedDateLabels: trim(openDate),
    closedDateIso: trim(openDateIso),
    trim,
  };
}
